<template>
  <div>

    <div class="score-container" v-if="currentReport">
      <h3 class="title">Documents</h3>
      <div class="score" v-bind:style="getScoreStyle(currentReport.percentage)">
        <span>{{currentReport.percentage}} %</span>
      </div>
      <div style="margin-left: auto;"><b>{{user}}</b></div>
    </div>
    <div style="clear:both"></div>

    <div v-if="currentReport">
      <div class="report-wrapper">
        <table class="table table-responsive">
          <thead>
          <tr>
            <td width="30%">Client file name</td>
            <td width="30%">Alternate names</td>
            <td width="25%">FCA Regulations/Resources</td>
            <td width="5%">RAG Score</td>
            <td width="25%">Action/Notes</td>
            <td width="15%">File download</td>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in currentReport.documents" :key="item.id">
            <td>{{item.title}}</td>

<!--            <td>-->
<!--              <ul v-if="item.alternative_names?.length" class="alt-names">-->
<!--                <li v-for="(name, index) in item.alternative_names" :key="index">-->
<!--                  {{ name }}-->
<!--                </li>-->
<!--              </ul>-->
<!--              <span v-else>-</span>-->
<!--            </td>-->

            <td>
              <div v-if="!item.editAlternativeNames">
                <ul v-if="item.alternative_names?.length" class="alt-names">
                  <li v-for="(name, index) in item.alternative_names" :key="index">
                    {{ name }}
                  </li>
                </ul>

                <span v-else>-</span>

                <br />

                <a
                    class="add-note"
                    v-on:click.prevent.stop="startEditAlternativeNames(item)"
                >
                  <i class="fa fa-pencil"></i>
                  Edit
                </a>
              </div>

              <div v-else>
                <div
                    v-for="(name, index) in item.editableAlternativeNames"
                    :key="index"
                    class="alternative-name-row"
                >
                  <input
                      type="text"
                      class="form-control alternative-name-input"
                      v-model="item.editableAlternativeNames[index]"
                      :disabled="isDefaultAlternativeName(item, name)"
                  />

                  <button
                      v-if="!isDefaultAlternativeName(item, name)"
                      type="button"
                      class="btn btn-xs btn-danger note-button"
                      @click="removeAlternativeName(item, index)"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </div>

                <button
                    type="button"
                    class="btn btn-primary note-button"
                    @click="addAlternativeName(item)"
                >
                  <i class="fa fa-plus"></i>
                  Add
                </button>

                <br />

                <button
                    type="button"
                    class="btn btn-primary note-button"
                    @click="saveAlternativeNames(item)"
                    :disabled="item.isSavingAlternativeNames"
                >
                  Save
                </button>

                <button
                    type="button"
                    class="btn btn-secondary note-button"
                    @click="cancelEditAlternativeNames(item)"
                    :disabled="item.isSavingAlternativeNames"
                >
                  Cancel
                </button>

                <div v-if="item.isSavingAlternativeNames" class="status-message">
                  Saving...
                </div>

                <div v-if="item.alternativeNamesSaveStatus === 'success'" class="status-message success">
                  Alternative names saved successfully!
                </div>

                <div v-if="item.alternativeNamesSaveStatus === 'error'" class="status-message error">
                  Error saving alternative names.
                </div>
              </div>
            </td>

            <td>
              <p class="print-link" v-for="resource in item.fca_resource" :key="resource.link">
                <a style="color: #337ab7;" :href="resource.link" target="_blank">{{resource.text}}</a>
              </p>
            </td>

            <td>
              <div :class="{'color': true, 'yellow': item.status === 'yellow', 'green': item.status === 'green'}"></div>
            </td>

            <td>
              <div class="row row-comment" v-for="i in item.notes" :key="i.id">
                <div class="col-md-8 card-title card-title-300">
                  {{ i.note }}
                </div>
                <div class="col-md-4 card-title card-title-300">
                  <span v-if="i.user.account_role === 'auditor'" class="auditor-pill">Auditor<br /></span>{{ i.user.first_name }} {{ i.user.last_name }}<br />
                  {{ formatDate(i.created_at, i.updated_at) }}
                </div>
              </div>

              <a v-if="!item.showTextarea" class="add-note" v-on:click.prevent.stop="item.showTextarea = true">
                <i class="fa fa-plus"></i>
                Add Note
              </a>

              <div v-if="item.showTextarea">
                <textarea
                    class="notice-textarea"
                    :class="{ 'saving': item.isSaving, 'saved': item.saveStatus === 'success', 'error': item.saveStatus === 'error' }"
                    maxlength="1000"
                    v-model="item.newNote"
                    style="width: 100%; min-height: 100px">
                </textarea>

                <button @click="saveNote(item)" class="btn btn-primary note-button">Save</button>
                <button @click="item.showTextarea = false; item.newNote = '';" class="btn btn-secondary note-button">Cancel</button>

                <div v-if="item.isSaving" class="status-message">Saving...</div>
                <div v-if="item.saveStatus === 'success'" class="status-message success">Note saved successfully!</div>
                <div v-if="item.saveStatus === 'error'" class="status-message error">Error saving note.</div>
              </div>
            </td>

            <td class="text-right">
              <div class="print-link file-entry" v-for="(file, index) in item.files" :key="file.download_link">
                <a v-if="file.download_link" :href="file.download_link" class="file-name">
                  <i class="fa fa-download"></i> {{file.original_filename}}
                </a>

                <div v-if="item.status === 'green' && item.monitor_document_type_slug" class="monitor-audit">
                  <a v-if="getMonitorDocumentId(item, index)" :href="'/documents/view/' + getMonitorDocumentId(item, index)" target="_blank">
                    <i class="fa fa-check-circle"></i> View report
                  </a>
                  <template v-else>
                    <a v-if="getAuditStatus(item, index) !== 'loading'" class="add-note" v-on:click.prevent.stop="auditInMonitor(item, index)">
                      <i class="fa fa-magic"></i> Audit in Monitor
                    </a>
                    <span v-else><i class="fa fa-spinner fa-spin"></i> Auditing...</span>
                    <div v-if="getAuditStatus(item, index) === 'error'" class="status-message error">{{ getAuditError(item, index) }}</div>
                  </template>
                </div>
              </div>
            </td>
          </tr>

          <tr v-for="item in currentReport.other_documents" :key="item.id">
            <td><span v-if="item.category_by_ai">( {{item.category_by_ai}} ) </span>{{item.title}}</td>
            <td>
              <div :class="{'color': true, 'yellow': item.status === 'yellow', 'green': item.status === 'green'}"></div>
            </td>

            <td>
              <p class="print-link">
                <a v-if="item.download_link" :href="item.download_link"><i class="fa fa-download"></i> {{item.original_filename}}</a>
              </p>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "IntellifloOfficeDocumentsReportComponent",
  props: [
    "report",
    "user"
  ],
  data() {
    return {
      currentReport: [],
    }
  },
  mounted() {
    this.currentReport = JSON.parse(this.report);

    // this.currentReport.documents.forEach(doc => {
    //   doc.showTextarea = false;
    //   doc.newNote = '';
    // });
    this.currentReport.documents.forEach(doc => {
      doc.showTextarea = false;
      doc.newNote = '';

      doc.editAlternativeNames = false;
      doc.editableAlternativeNames = [];
      doc.isSavingAlternativeNames = false;
      doc.alternativeNamesSaveStatus = null;

      if (!Array.isArray(doc.alternative_names)) {
        doc.alternative_names = [];
      }

      doc.monitor_document_ids = doc.monitor_document_ids || {};
      doc.auditInMonitorStatus = {};
      doc.auditInMonitorError = {};
    });
  },
  methods: {
    getScoreStyle(score) {
      let color = '#2ECC71';
      let border = 'transparent';
      if (score === 0) {
        border = '#81c6e9';
        color = 'transparent';
      } else if (score < 34) {
        color = '#DE301D';
      } else if (score < 68) {
        color = '#F1C40F';
      }

      return {
        backgroundColor: color,
        borderColor: border,
      };
    },
    saveNote(item) {
      item.isSaving = true;
      item.saveStatus = null;

      axios.post('/io/documents/report/save/notes', {
        id: item.id,
        notes: item.newNote,
      }).then(response => {
        item.saveStatus = 'success';
        item.notes.push({
          note: response.data.item.note ?? null,
          user: response.data.item.user ?? {},
          created_at: new Date(response.data.item.created_at).toISOString(),
          updated_at: new Date(response.data.item.updated_at).toISOString()
        });
        item.newNote = '';
        item.showTextarea = false;
        setTimeout(() => {
          item.saveStatus = null;
        }, 3000);
      }).catch(error => {
        item.saveStatus = 'error';
        setTimeout(() => {
          item.saveStatus = null;
        }, 3000);
      }).finally(() => {
        item.isSaving = false;
      });
    },
    formatDate: function (created_at, updated_at) {
      let date = null;
      if (created_at || updated_at) {
        if (created_at) {
          date = created_at;
        } else {
          date = updated_at;
        }
        date = moment(date, "YYYY-MM-DD h:imm:ss").format("DD.MM.YYYY  HH:mm:ss");
      }

      return date;
    },
    startEditAlternativeNames(item) {
      item.editableAlternativeNames = [...(item.alternative_names || [])];
      item.editAlternativeNames = true;
      item.alternativeNamesSaveStatus = null;
    },

    addAlternativeName(item) {
      item.editableAlternativeNames.push('');
    },

    removeAlternativeName(item, index) {
      item.editableAlternativeNames.splice(index, 1);
    },

    cancelEditAlternativeNames(item) {
      item.editAlternativeNames = false;
      item.editableAlternativeNames = [];
      item.alternativeNamesSaveStatus = null;
    },

    saveAlternativeNames(item) {
      item.isSavingAlternativeNames = true;
      item.alternativeNamesSaveStatus = null;

      axios.post('/io/documents/report/save/alternative-names', {
        intelligent_office_data_id: item.intelligent_office_data_id,
        title: item.title,
        alternative_names: item.editableAlternativeNames,
      }).then(response => {
        item.alternative_names = response.data.alternative_names || [];
        item.editableAlternativeNames = [...item.alternative_names];
        item.editAlternativeNames = false;
        item.alternativeNamesSaveStatus = 'success';

        setTimeout(() => {
          item.alternativeNamesSaveStatus = null;
        }, 3000);
      }).catch(error => {
        item.alternativeNamesSaveStatus = 'error';

        setTimeout(() => {
          item.alternativeNamesSaveStatus = null;
        }, 3000);
      }).finally(() => {
        item.isSavingAlternativeNames = false;
      });
    },
    isDefaultAlternativeName(document, name) {
      return (document.default_alternative_names || []).includes(name);
    },
    getMonitorDocumentId(item, index) {
      return (item.monitor_document_ids || {})[index];
    },
    getAuditStatus(item, index) {
      return (item.auditInMonitorStatus || {})[index];
    },
    getAuditError(item, index) {
      return (item.auditInMonitorError || {})[index];
    },
    auditInMonitor(item, index) {
      item.auditInMonitorStatus[index] = 'loading';
      item.auditInMonitorError[index] = null;

      axios.post('/io/documents/audit-in-monitor', {
        type: 'file',
        id: item.id,
        file_index: index,
      }).then(response => {
        item.monitor_document_ids[index] = response.data.monitor_document_id;
        item.auditInMonitorStatus[index] = 'success';
      }).catch(error => {
        item.auditInMonitorStatus[index] = 'error';
        item.auditInMonitorError[index] = error.response?.data?.message || 'Error auditing document in Monitor.';
      });
    },
  },
}
</script>


<style>
.color {
  border-left: 15px solid #DE301D;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-right: 5px;
}
.color.yellow {
  border-left: 15px solid #F1C40F;
}
.color.green {
  border-left: 15px solid #2ECC71;
}
.score-container {
  display: flex;
  align-items: center;
}
.score {
  width: 45px;
  height: 45px;
  font-size: 0.9em;
  border-radius: 100%;
  border: 2px solid;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title {
  margin-right: 10px;
}
.print-link {
  max-width: 300px;
}
.file-entry {
  display: block;
  text-align: left;
  background-color: #f4f7f7;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  padding: 6px 10px;
  margin-bottom: 6px;
}
.file-entry .file-name {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notice-textarea {
  border: 1px solid #ccc;
}

.notice-textarea.saving {
  border-color: #007bff;
}

.notice-textarea.saved {
  border-color: #28a745;
}

.notice-textarea.error {
  border-color: #dc3545;
}

.status-message {
  margin-top: 5px;
}

.status-message.success {
  color: #28a745;
}

.status-message.error {
  color: #dc3545;
}
.row-comment:not(:last-child) {
  border-bottom: 1px solid #ccc;
  padding-bottom: 2px;
  margin-bottom: 2px;
}
:not(.input-group-btn) > .note-button {
  margin: 5px 5px;
  padding: 2px 10px
}
@media print {
  .print-link a::after {
    content: "";
  }
}

.alternative-name-row {
  display: flex;
  gap: 5px;
  margin-bottom: 5px;
}

.alternative-name-input {
  width: 100%;
}

.alt-names {
  padding-left: 15px;
  margin-bottom: 5px;
}
.add-note {
  cursor: pointer;
}
.monitor-audit {
  display: block;
  margin-top: 4px;
  padding-top: 4px;
  border-top: 1px dashed #dcdcdc;
  white-space: nowrap;
}
.monitor-audit .status-message {
  white-space: normal;
  word-break: break-word;
}
</style>